export const headCellsTags = [
    { id: 'bulk', numeric: false, disablePadding: false, label: '', sorted: true },
    { id: 'name', numeric: false, disablePadding: false, label: 'Name', sorted: true },
    { id: 'related', numeric: true, disablePadding: false, label: 'Count', sorted: false },
];
